import { render, staticRenderFns } from "./MyVendor.vue?vue&type=template&id=4dcd8ab0&scoped=true&"
import script from "./MyVendor.vue?vue&type=script&lang=js&"
export * from "./MyVendor.vue?vue&type=script&lang=js&"
import style0 from "./MyVendor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd8ab0",
  null
  
)

export default component.exports